<ng-template editorInputTemplate [currentComponent]="currentComponent"></ng-template>
<!-- <p>shit works</p> -->
